module.exports = __webpack_public_path__ + "static/PenthouseKitchenTerraceDesktop-ef0d0f2306501f002c8096031314fbab.jpg";